import React, { useState } from 'react';
import { Button, Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import ApiService from '../../service/apiService';
import logUtils from '../../HelperMethods/LogUtils';

async function reportError(message, errorObject, errorInfo, appState) {
  const stackTrace = `${errorObject.stack}<br/>${JSON.stringify(errorInfo)}`;
  const stateInString = JSON.stringify(appState);
  const localStorageInString = JSON.stringify(localStorage);
  try {
    await ApiService.sendErrorLogToJoyn2Team({
      message,
      appState: stateInString,
      stackTrace,
      localStorage: localStorageInString,
    });
  } catch (e) {
    logUtils.logError(e);
  }
  return true;
}

function ReportError({ errorLog, errorInfo, appState }) {
  const [uponReportMessage, setUponReportMessage] = useState(
    'Error log has been attached, please mention the scenario for which error has happened'
  );
  const [disableReportButton, setDisableReportButton] = useState(false);
  return (
    <div
      style={{
        position: 'fixed',
        top: '0px',
        left: '0px',
        height: '100%',
        width: '100%',
        background: 'black',
        opacity: '0.5',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div>
        <Form.Field>
          <textarea
            style={{ background: 'white', width: '400px', height: '200px' }}
            type="text"
            placeholder="Report Bug"
            id="report-error-textarea"
          />
          <br />
          <Button
            type="button"
            disabled={disableReportButton}
            onClick={async () => {
              setDisableReportButton(true);
              const message = document.getElementById('report-error-textarea').value;
              const reportResponse = await reportError(message, errorLog, errorInfo, appState);
              if (reportResponse) {
                let timeRemaining = 5;
                setUponReportMessage(`Reported successfully!!, Loading page in ${(timeRemaining -= 1)} seconds`);
                setInterval(() => {
                  setUponReportMessage(`Reported successfully!!, Loading page in ${(timeRemaining -= 1)} seconds`);
                  if (timeRemaining === 0 && window.parent && window.parent.window.location) {
                    window.parent.window.location.reload();
                  }
                }, 1000);
              }
            }}
            style={{
              background: 'white',
              width: '100%',
            }}
          >
            Report
          </Button>
          <br />
          {uponReportMessage && <p style={{ color: 'white', width: '400px' }}>{uponReportMessage}</p>}
        </Form.Field>
      </div>
    </div>
  );
}

ReportError.propTypes = {
  errorLog: PropTypes.any,
  errorInfo: PropTypes.any,
  appState: PropTypes.object.isRequired,
};

export default ReportError;
